<template>
  <div></div>
</template>

<script>
export default {
  name: `Messages`
};
</script>
